import axios from 'axios'
import { PaginateModel } from '../../../shared/models/PaginateModel'
import { ItemOptionModel } from '../../orders/models/ItemOptionModel'
import { ItemOutputModel } from '../models/ItemOutputModel'
import {
    ItemProcessHistoryFilterModel,
    ItemProcessHistoryListResponseModel,
    ItemProcessHistoryModel,
} from '../models/ItemProcessHistoryModel'
import { cleanupPaginationParams } from '../../../shared/utils'


const API_URL = process.env.REACT_APP_API_URL

const BASE_ITEM_URL = `${API_URL}/items`
/**
 * 
 * @param params 
 * @returns 
 */
export function getItems(params: PaginateModel) {
    return axios.get(BASE_ITEM_URL, {
        params: cleanupPaginationParams(params),
    })
}
/**
 * 
 * @returns 
 */
export function getAllItemsStatus() {
    return axios.get(BASE_ITEM_URL + '/status')
}



/**
 * 
 * @param id 
 * @returns 
 */
export function getDetailItem(id: string) {
    return axios.get<any>(BASE_ITEM_URL + "/" + id)
}
/**
 * 
 * @param id 
 * @returns 
 */
export function getDetailItemOutput(id: string) {
    return axios.get<any>(BASE_ITEM_URL + "/" + id + "/output")
}

/**
 * 
 * @param id 
 * @returns 
 */
export function updateItemImage(newItem: ItemOutputModel) {
    return axios.put<any>(BASE_ITEM_URL + "/" + newItem.id + "/output",
        newItem
    )
}
/**
 * 
 * @param id 
 * @returns 
 */
export function updateDetailItem(id: number, star: number) {
    return axios.put<any>(BASE_ITEM_URL + "/" + id + "/star", {
        star: star
    })
}


export function retryAiWithSetting(id: number, settings?: ItemOptionModel[] | undefined) {
    return axios.put<any>(BASE_ITEM_URL + "/" + id + "/ai-retry", {
        settings
    })
}

export function getItemProcessHistories(id: number, params?: ItemProcessHistoryFilterModel) {
    return axios.get<ItemProcessHistoryListResponseModel>(BASE_ITEM_URL + '/' + id + '/process-histories', {
        params: cleanupPaginationParams(params || {}),
    })
}

export async function getAllItemProcessHistories(
    id: number,
    processId?: number
): Promise<ItemProcessHistoryModel[]> {
    const maxTake = 50
    let page = 1
    let hasNextPage = true
    const allHistories: ItemProcessHistoryModel[] = []

    while (hasNextPage) {
        const response = await getItemProcessHistories(id, {
            page,
            take: maxTake,
            processId,
        })
        const data = response.data
        allHistories.push(...(data?.data || []))

        if (!data?.meta) {
            break
        }

        hasNextPage = !!data.meta.hasNextPage
        page += 1

        if (data.meta.pageCount && page > data.meta.pageCount) {
            break
        }
    }

    return allHistories
}

export function updateItemOutputByHistory(
    id: number,
    payload: { processId: number; historyId: number; output?: string }
) {
    return axios.put<any>(BASE_ITEM_URL + '/' + id + '/output', payload)
}

/**
 * Set a process history output as the main output for an item
 * @param id - Item ID
 * @param historyId - Process history ID to use
 * @returns OrderItemDto
 */
export function setHistoryAsMainOutput(id: number, historyId: number) {
    return axios.put<any>(
        BASE_ITEM_URL + '/' + id + '/process-histories/' + historyId + '/use-main-output'
    )
}
